import React, { useContext } from 'react';
import { KazooContext } from './provider';

export function useKazoo() {
    const context = useContext(KazooContext);

    if (!context) throw new Error('useKazoo must be used within a KazooProvider');

    return context;
}
